import { Container, Resource, Sprite, Texture } from "pixi.js";

export class VerticalScrollBar extends Container {
    public scrollZoneOffset: number;
    public liftXOffset: number;

    private readonly scrollResources: ScrollResources;

    private upArrow?: Sprite;
    private line: Sprite;
    private lift: Sprite;
    private downArrow?: Sprite;

    private scrollZoneProperty: number;

    public get scrollZone(): number { return this.scrollZoneProperty }
    public set scrollZone(value: number) {
        if (value === this.scrollZoneProperty) {
            return;
        }
        this.scrollZoneProperty = value;
        this.updateLift();
    }

    private scrollSizeProperty: number;

    public get scrollSize(): number { return this.scrollSizeProperty }
    public set scrollSize(value: number) {
        if (value === this.scrollSizeProperty) {
            return;
        }
        this.scrollSizeProperty = value;
        this.updateLift();
    }

    public constructor(myBuildingResources: ScrollResources, scrollZone: number = 0, scrollSize: number = 0, offset: number = 0, liftXOffset: number = 0) {
        super();
        this.scrollResources = myBuildingResources;
        this.liftXOffset = liftXOffset;
        this.scrollZoneOffset = offset;
        this.build();
        this.scrollZone = scrollZone;
        this.scrollSize = scrollSize;
    }

    private build(): void {
        if (this.scrollResources.arrow != null) {
            this.upArrow = new Sprite(this.scrollResources.arrow);
            this.addChild(this.upArrow);
        }

        this.line = new Sprite(this.scrollResources.line);
        this.line.position.set((this.upArrow?.width ?? 0 - this.line.width) * 0.5, this.upArrow?.height ?? 0 - 10);
        this.addChild(this.line);

        this.lift = new Sprite(this.scrollResources.lift);
        this.lift.position.set(this.line.position.x + this.liftXOffset, this.line.position.y + this.scrollZoneOffset);
        this.addChild(this.lift);

        if (this.scrollResources.arrow != null) {
            this.downArrow = new Sprite(this.scrollResources.arrow);
            this.downArrow.rotation = Math.PI;
            this.downArrow.position.set(this.downArrow.width, this.upArrow.height + this.line.height + this.downArrow.height - 10);
            this.addChild(this.downArrow);
        }
    }

    private updateLift(): void {
        if (this.scrollSizeProperty === 0 || this.scrollZone >= this.scrollSize + this.scrollZoneOffset) {
            this.lift.height = this.line.height;
            return;
        }

        this.lift.height = this.line.height * this.scrollZone / (this.scrollSize + this.scrollZoneOffset);
    }

    public updateScroll(scrollValue: number): void {
        const clampedValue = Math.min(Math.max(scrollValue, 0), this.scrollSize - (this.scrollZone + this.scrollZoneOffset * 2));
        this.lift.position.y = this.line.position.y + this.scrollZoneOffset + Math.round((this.line.height - this.lift.height - this.scrollZoneOffset * 2) * (clampedValue / (this.scrollSize - this.scrollZone)));
    }
}

type ScrollResources = {
    line: Texture<Resource>;
    lift: Texture<Resource>;
    arrow?: Texture<Resource>;
}